import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {ThreeColumnLayout, TwoColumnLayout} from '@/component';
import {Input, Tabs} from 'antd';
import UserList from '@/page/conversation/ConPage/UserList';
import {useAuthStore} from '@/context/auth';
import _ from 'lodash';
import ConversationContext from '@/page/conversation/ConPage/conversationContext';
import Content from '@/page/conversation/ConPage/Content';
import AppLayout from '@/page/component/AppLayout';
import AppLayoutHeader from '@/page/component/AppLayout/AppLayoutHeader';
import styles from './index.module.less';

const {Search} = Input;
const {TabPane} = Tabs;

/**
 * 通用会话相关组件（整合版本）
 * @constructor
 */
export default function NormalConComponent({receiveTabs, sendType, title}) {
    const [authStore] = useAuthStore();
    const userId = _.get(authStore, 'user.id');
    const [fromType, setFromType] = useState(sendType);
    const [from, setFrom] = useState({});
    const [receiveType, setReceiveType] = useState(receiveTabs[0].key);
    const [receive, setReceive] = useState({});
    const [filterParams, setFilterParams] = useState({
        s: '',
        userId,
        size: 15,
    });
    const [filterSecondParams, setFilterSecondParams] = useState({
        s: '',
        size: 15,
    });

    function onSearch(e) {
        let filter = {...filterParams};
        filter.s = e;
        setFilterParams(filter);
    }

    function onSecondSearch(e) {
        let filter = {...filterSecondParams};
        filter.s = e;
        setFilterSecondParams(filter);
    }

    function changeReceiveTab(type) {
        setReceive({});
        setReceiveType(parseInt(type, 10));
        setFilterSecondParams({s: '', size: 15});
    }

    return (
        <AppLayout header={<AppLayoutHeader subTitle={title} />}>
        <TwoColumnLayout className={styles.conPage}>
            <ConversationContext.Provider value={{from, setFrom, receive, setReceive}}>
                <TwoColumnLayout.SidePanel>
                    <TwoColumnLayout.PanelHeader title={title} />
                    <div className={styles.container}>
                        <Search
                            placeholder="请输入..."
                            className={styles.search}
                            onSearch={onSearch}
                        />
                        <div
                            style={{
                                // overflowY: 'auto',
                                overflowX: 'hidden',
                                // height: '80vh',
                            }}
                        >
                            <UserList
                                url={`/cons/list/${fromType}`}
                                filterParams={filterParams}
                                newClass={styles.userList}
                            />
                        </div>
                    </div>
                </TwoColumnLayout.SidePanel>
                <TwoColumnLayout.SidePanel>
                    <ThreeColumnLayout.PanelHeader title={from.name ? from.name : '未选择用户'} />
                    <ThreeColumnLayout.PanelContent>
                        <Search
                            placeholder="请输入..."
                            className={styles.customerSearch}
                            onSearch={onSecondSearch}
                        />
                    </ThreeColumnLayout.PanelContent>
                    {receiveTabs.length === 1 ? (
                        <div
                            style={{
                                marginTop: '45px',
                                // overflowY: 'auto',
                                overflowX: 'hidden',
                                // height: '80vh',
                            }}
                        >
                            <UserList
                                url={
                                    !_.isEmpty(from)
                                        ? `/cons/search/contact/${
                                              fromType === 0 ? from.extId : from.externalUserId
                                          }/${receiveType}/${fromType}`
                                        : null
                                }
                                receiveType={receiveType}
                                filterParams={filterSecondParams}
                                type={1}
                            />
                        </div>
                    ) : (
                        <Tabs onChange={changeReceiveTab} centered={true} className={styles.from}>
                            {receiveTabs.map((item, i) => (
                                <TabPane tab={item.name} key={item.key}>
                                    {receiveType == item.key && (
                                        <div
                                            style={{
                                                // overflowY: 'auto',
                                                overflowX: 'hidden',
                                                // height: '80vh',
                                            }}
                                        >
                                            <UserList
                                                url={
                                                    !_.isEmpty(from)
                                                        ? `/cons/search/contact/${
                                                              fromType === 0
                                                                  ? from.extId
                                                                  : from.externalUserId
                                                          }/${receiveType}/${fromType}`
                                                        : null
                                                }
                                                key={i}
                                                receiveType={receiveType}
                                                filterParams={filterSecondParams}
                                                type={1}
                                            />
                                        </div>
                                    )}
                                </TabPane>
                            ))}
                        </Tabs>
                    )}
                </TwoColumnLayout.SidePanel>
                <TwoColumnLayout.ContentPanel className={styles.content}>
                    <div
                        style={{
                            overflowY: 'auto',
                            overflowX: 'hidden',
                        }}
                    >
                        <div className={styles.title}>
                            {!_.isEmpty(receive) ? receive.name + '会话' : '暂无会话'}
                        </div>
                        <Content
                            receiveType={receiveType}
                            receive={receive}
                            from={from}
                            fromType={fromType}
                        />
                    </div>
                </TwoColumnLayout.ContentPanel>
            </ConversationContext.Provider>
        </TwoColumnLayout>
        </AppLayout>
    );
}

NormalConComponent.propTypes = {
    // 接收用tabs
    receiveTabs: PropTypes.array.isRequired, // 发送人员类型(0 员工 1 客户)
    sendType: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
};
